const AUTH_USER_ID_KEY = 'authUserId';

export const normalizeAuthUserId = (value) => {
  if (typeof value !== 'string' && typeof value !== 'number') return null;

  const normalized = String(value).trim();
  return /^\d+$/.test(normalized) ? normalized : null;
};

export const readAuthUserId = (storage = sessionStorage) => {
  const stored = storage.getItem(AUTH_USER_ID_KEY);
  const normalized = normalizeAuthUserId(stored);

  if (!normalized && stored !== null) storage.removeItem(AUTH_USER_ID_KEY);
  return normalized;
};

export const writeAuthUserId = (value, storage = sessionStorage) => {
  const normalized = normalizeAuthUserId(value);

  if (!normalized) {
    storage.removeItem(AUTH_USER_ID_KEY);
    return null;
  }

  storage.setItem(AUTH_USER_ID_KEY, normalized);
  return normalized;
};

export const applyAuthUserIdHeader = (headers, value) => {
  const normalized = normalizeAuthUserId(value);

  if (normalized) {
    if (typeof headers.set === 'function') headers.set(AUTH_USER_ID_KEY, normalized);
    else headers.authUserId = normalized;
  } else if (typeof headers.delete === 'function') {
    headers.delete(AUTH_USER_ID_KEY);
  } else {
    delete headers.authUserId;
  }

  return normalized;
};
